import Vue from 'vue';
import Router from 'vue-router';
import 'nprogress/nprogress.css';
import modules from '@/core/module';
import { overridable } from '@/core/template-engine';
import { setupRouterGuards, patchRouterPush } from './guards';

Vue.use(Router);

export default function createRouter() {
    const routes = [
        ...modules.routes(),
        {
            path: '*',
            name: 'notFound',
            component: overridable('NotFound', () => import(/* webpackChunkName: "not-found" */ '@/core/NotFound.vue'))
        }
    ];

    const router = new Router({
        mode: 'history',
        linkActiveClass: 'active',
        routes,
        scrollBehavior(to, from) {
            if (to.path === from.path) return false;
            return { x: 0, y: 0 };
        }
    });

    setupRouterGuards(router);
    patchRouterPush();

    return router;
}
